import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ServerService} from '../service/server.service';
import {
  AlertController,
  IonRouterOutlet,
  LoadingController,
  ModalController,
  NavController,
  ToastController
} from '@ionic/angular';
import {ProductAddPage} from './product-add/product-add.page';
import {Constant} from "../shared/model/Constant";
import {AdminService} from "../service/admin.service";
import {SettingAddPage} from "./product-add/setting-add/setting-add.page";
import {SearchUtil} from "../shared/utils/SearchUtil";
import {ProductService} from "../service/product.service";

@Component({
  selector: 'app-products',
  templateUrl: './product.page.html',
  styleUrls: ['./product.page.scss'],
})

export class ProductPage implements OnInit {

  data: any;
  user: any;
  q: any;
  text: any;
  products: any[];
  loading: HTMLIonLoadingElement;
  productFiltered: any[];


  constructor(private routerOutlet: IonRouterOutlet,
              public modalController: ModalController,
              public alertController: AlertController,
              private route: ActivatedRoute,
              public server: ServerService,
              public toastController: ToastController,
              private nav: NavController,
              public loadingController: LoadingController,
              private adminService: AdminService,
              private productService: ProductService,) {


  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await this.loadData();
  }

  async loadData() {
    await this.loading.present();
    this.productService.getProduct().subscribe((response: any[]) => {
      this.loading.dismiss();
      this.products = response;
    }, error => {
      console.warn('Error al consultar Productos', error);
      this.loading.dismiss();
      this.presentToast(error.error.error);
    });



  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  async presentAlert(id) {
    const alert = await this.alertController.create({
      header: this.text.are_you_sure,
      message: this.text.want_delete,
      mode: 'ios',
      buttons: [
        {
          text: this.text.cancel,
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.text.yes,
          role: 'confirm',
          handler: () => {
            this.remove(id);
          }
        }
      ]
    });

    await alert.present();

    const {role} = await alert.onDidDismiss();

  }

  async remove(id) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();

    this.server.removeClient(id).subscribe((response: any) => {

      this.data = response.data;

      loading.dismiss();

    });
  }

 /* edit(pro) {
    localStorage.setItem('client_data', JSON.stringify(pro));

    this.nav.navigateForward('/client-add/' + pro.id);

  } */

  async addProduct(data = []) {
    const modal = await this.modalController.create({
      component: ProductAddPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
      componentProps: {
        data,
      }
    });
    modal.onDidDismiss().then(data => {
      if (data) {
        this.loadData();
      }
    });
    return await modal.present();
  }

  async add(data) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();

    this.server.clientAdd(data).subscribe((response: any) => {

      this.data = response.data;

      loading.dismiss();

    });
  }

  onChangePage(event: any) {
    this.productFiltered = event; //this.pageOfItems = pageOfItems;
  }


  async addSetting(data = []) {
    const modal = await this.modalController.create({
      component: SettingAddPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
      componentProps: {
        data,
      }
    });
    modal.onDidDismiss().then(data => {
      if (data) {
        this.loadData();
      }
    });
    return await modal.present();
  }

  search(event: any) {
    if (event && event.detail && event.detail.value) {
      const result = SearchUtil.findMatchingPositions(this.products, event.detail.value);
      this.productFiltered= result;
    }
    if (event.detail.value === '') {
      this.productFiltered = this.products;
    }
  }
  }

